<div class="component-container flex flex-col xs:p-[2rem] sm:p-[1rem] md:p-[2.7rem]">
  <div class="dashboard-filter w-full">
    <div class="row flex flex-row justify-center items-center xs:px-[5rem] sm:px-[5rem] md:px-[10rem] lg:px-[18.3rem]">
      <div class="label flex flex-row">
        Dashboard <span class="required-mark">*</span>
      </div>
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['dashboard']"
        [options]="dashboardFilterList"
        [parentFormGroup]="form"
        class="input dashboard-input w-full"
        controlName="dashboard"
        placeholder="Select one"
        type="small"
      />
    </div>
  </div>
  <div class="filter-section w-full">
    <ng-template
      filterHost
    ></ng-template>
  </div>
  <div
    class="table-section"
  >
    <mat-expansion-panel
      [expanded]="expandPanel"
      class="mat-elevation-z0 expansion-panel w-full"
    >
      <mat-expansion-panel-header
        class="bg-black-100 expansion-panel-header justify-center"
      >
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          {{ heading }} Dashboard
        </div>
      </mat-expansion-panel-header>
      <div
        *ngIf="!expandPanel; else tableData"
        class="no-data flex justify-center items-center"
      >
        No Dashboard Selected!
      </div>
      <div
        class="each-table-section"
      >
        <ng-template
          #tableData
          tableHost
        ></ng-template>
      </div>
    </mat-expansion-panel>
  </div>
</div>
